export default "/_next/static/images/investors-mobile-41874a95f7064ad897334054967b600b.png";